import { CommonUtils } from "fwork-jsts-common/src";
import { IParam } from "fwork.react.test/src/components/ctrlParams/models";
import moment, { Moment } from "moment";

export function replaceParamsScript(script: string, params: IParam[] | undefined) {
  var s = script;
  if (!params?.length) return s

  const paramsTmp = JSON.parse(JSON.stringify(params))

  if (paramsTmp?.length)
    for (var p of paramsTmp) {
      let isDate = moment(p.value, moment.ISO_8601).isValid()
      let hasDot = (p.value as string).includes(':')
      if (isDate && hasDot) {
        p.value = moment(p.value).subtract({ hour: 3 }).toISOString()
      }

      s = s.replace(new RegExp('\\[' + p.paramName + ']', 'g'), typeof p.value === 'string' ? `'${p.value}'` : p.value);
    }
  return s;
}